import React from 'react'
import {  Redirect, Route, Switch } from 'react-router-dom'
import { CiudadesPage } from '../components/dashboard/ciudades/CiudadesPage'
import { DetalleImpuestoPage } from '../components/dashboard/detalleimpuestos/DetalleImpuestoPage'
import { HomePage } from '../components/dashboard/home/HomePage'
import { MembresiaPage } from '../components/dashboard/membresias/MembresiaPage'
import { NameImpuestoPage } from '../components/dashboard/nameimpuestos/NameImpuestoPage'
import { UsuarioPage } from '../components/dashboard/users/UsuarioPage'
import { Footer } from '../components/structure/Footer'

import { Navbar } from '../components/structure/Navbar'
import { Sidebar } from '../components/structure/Sidebar'
import { EditarImpuestoPage } from '../components/dashboard/editar-impuestos/EditarImpuestoPage'
import { CompraMembresiasPage } from '../components/dashboard/compra-membresias/CompraMembresiasPage'

export const DashboardRouter = () => {
    return (
        <div>
            <Navbar />
            <Sidebar />
            <Switch>
                <Route exact path="/dashboard/home" component={HomePage} />
                <Route exact path="/dashboard/usuario" component={UsuarioPage} />
                <Route exact path="/dashboard/ciudades" component={CiudadesPage} />
                <Route exact path="/dashboard/detalleimpuesto" component={DetalleImpuestoPage} />
                <Route exact path="/dashboard/nombreimpuesto" component={NameImpuestoPage} />
                <Route exact path="/dashboard/membresias" component={MembresiaPage} />
                <Route exact path="/dashboard/editarimpuestos" component={EditarImpuestoPage} />
                <Route exact path="/dashboard/compraMembresias" component={CompraMembresiasPage} />
                <Redirect to="/auth/login" />

            </Switch>
            <Footer/>

        </div>
    )
}
